import React from 'react';
import { Button, Row, Col } from 'reactstrap';
import Translate from "./common/translation";
import { useParams } from "./contexts/parameters";
import { useWorkFlow, NEED_CONNECTION } from "./contexts/workflow";
import _Login from "./core/security";
var Connect = function Connect(props) {
  var required = props.required,
    setDisplay = props.setDisplay;
  var _useParams = useParams(),
    parameters = _useParams.parameters;
  var _useWorkFlow = useWorkFlow(),
    dispatcher = _useWorkFlow.dispatcher,
    actions = _useWorkFlow.actions;
  var notifier = parameters.notifier;
  var Login = _Login;
  var handleContinueForm = function handleContinueForm() {
    if (typeof setDisplay === 'function') {
      setDisplay(false);
    }
  };
  var handleOnSuccess = function handleOnSuccess() {
    notifier.success( /*#__PURE__*/React.createElement(Translate, {
      id: "connect"
    }), /*#__PURE__*/React.createElement(Translate, {
      id: "connect_success"
    }));
    dispatcher({
      type: NEED_CONNECTION,
      value: false
    });
    setDisplay(false);

    // actions.save();
  };
  var handleOnFailed = function handleOnFailed() {
    // notifier.error(<Translate id="connect" />, <Translate id="connect_error" />);
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-center collectorConnectContainer"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "6"
  }, /*#__PURE__*/React.createElement("h5", null, ' ', /*#__PURE__*/React.createElement(Translate, {
    id: "collector_connect_you"
  }), ' ', !required ? /*#__PURE__*/React.createElement(Translate, {
    id: "collector_connect_not_required"
  }) : /*#__PURE__*/React.createElement(Translate, {
    id: "collector_connect_required"
  }), ' '), /*#__PURE__*/React.createElement(Login, {
    onSuccess: handleOnSuccess,
    onFailed: handleOnFailed,
    actions: [!required && /*#__PURE__*/React.createElement(Button, {
      onClick: handleContinueForm,
      color: "info"
    }, /*#__PURE__*/React.createElement(Translate, {
      id: "collector_continue"
    }))]
  })));
};
export default Connect;